import {ethers} from "ethers";
import { ERC20ABI } from "./abi/ERC20ABI";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { WrappedETHABI } from "./abi/WrappedETHABI";

export class WrappedETHContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, WrappedETHABI.GetABI(), provider);
    }

    async deposit(amountEth:string): Promise<any>
    {
        const result = await this._pay(this._toWei(amountEth), 'deposit'); 
        return result;
    }

    async withdraw(amountEth:string): Promise<any>
    {
        const result = await this._send('withdraw', this._toWei(amountEth)); 
        return result;
    }
}